import { FlexBox, Table, Text } from '@dixa/lib-shared-habla';

import {
  CommandGroup,
  commandGroupAttributes,
  EnrichedCommand,
} from 'utils/commands';

import { KeybindingCommand } from '../command/keybindingCommand';

type KeybindingGroupProps = {
  group: CommandGroup;
  enrichedCommands: readonly EnrichedCommand[];
};

/**
 * Represents a component for displaying a group of commands and their
 * keybindings.
 */
export const KeybindingGroup = (props: KeybindingGroupProps): JSX.Element => {
  const { enrichedCommands, group } = props;
  const groupName = commandGroupAttributes[group].label;

  return (
    <FlexBox key={group} gap="300" flexDirection="column">
      <Text.Heading>{groupName}</Text.Heading>

      <Table hoverable>
        <Table.Tbody>
          {enrichedCommands.map((enrichedCommand) => (
            <KeybindingCommand
              key={enrichedCommand.command.name}
              enrichedCommand={enrichedCommand}
            />
          ))}
        </Table.Tbody>
      </Table>
    </FlexBox>
  );
};
